<p>list-detail works!</p>